import BaseModel from './BaseModel';

/** Class representing a section. */
class Section extends BaseModel {}

export default Section;
